<template>
  <div style="flex: 1">
    <vs-row>
      <vs-col
        vs-justify="center"
        vs-align="center"
        vs-lg="4"
        vs-sm="6"
        vs-xs="12"
      >
        <h6 class="mb-3">شروع تاریخ</h6>
        <date-picker
          v-model="startDate"
          format="YYYY-MM-DD"
          display-format="jYYYY-jMM-jDD"
          popover
          auto-submit
          @change="datePickerChanged"
        />
      </vs-col>
      <vs-col
        vs-justify="center"
        vs-align="center"
        vs-lg="4"
        vs-sm="6"
        vs-xs="12"
      >
        <h6 class="mb-3">پایان تاریخ</h6>
        <date-picker
          v-model="endDate"
          format="YYYY-MM-DD"
          display-format="jYYYY-jMM-jDD"
          :min="startDate"
          popover
          auto-submit
          @change="datePickerChanged"
        />
      </vs-col>
    </vs-row>
    <vs-row class="shortcut-container">
      <vs-button
        @click="selectShortcut('currentDay')"
        :class="[
          'shortcut-item',
          selectedShortcut === 'currentDay' && 'shortcut-item-selected',
        ]"
        >روز جاری</vs-button
      >
      <vs-button
        @click="selectShortcut('lastDay')"
        :class="[
          'shortcut-item',
          selectedShortcut === 'lastDay' && 'shortcut-item-selected',
        ]"
        >روز گذشته</vs-button
      >
      <vs-button
        @click="selectShortcut('currentWeek')"
        :class="[
          'shortcut-item',
          selectedShortcut === 'currentWeek' && 'shortcut-item-selected',
        ]"
        >هفته جاری</vs-button
      >
      <vs-button
        @click="selectShortcut('currentMonth')"
        :class="[
          'shortcut-item',
          selectedShortcut === 'currentMonth' && 'shortcut-item-selected',
        ]"
        >ماه جاری</vs-button
      >
    </vs-row>
  </div>
</template>

<script>
import moment from "jalali-moment";
import { mapGetters } from "vuex";
import { getBusinessDayMoment } from "../helpers/Functions";
import { timeOfTheWorkingDay } from "../helpers/Constants";

const Shortcuts = {
  NONE: "none",
  CURRENT_DAY: "currentDay",
  LAST_DAY: "lastDay",
  CURRENT_WEEK: "currentWeek",
  CURRENT_MONTH: "currentMonth",
};

export default {
  data() {
    const today = getBusinessDayMoment().format("YYYY-MM-DD");

    return {
      startDate: today,
      endDate: today,
      selectedShortcut: Shortcuts.CURRENT_DAY,
    };
  },
  computed: {
    ...mapGetters({
      currentProvider: "profile/currentProvider",
    }),
  },
  watch: {
    startDate() {
      this.onDateChanged(this.startDate, this.endDate);
    },
    endDate() {
      this.onDateChanged(this.startDate, this.endDate);
    },
  },
  methods: {
    selectShortcut(key) {
      this.selectedShortcut = key;

      const today = getBusinessDayMoment().format("YYYY-MM-DD");
      const yesterday = moment(today).add(-1, "days").format("YYYY-MM-DD");

      switch (key) {
        case Shortcuts.CURRENT_DAY:
          this.startDate = today;
          this.endDate = today;
          break;
        case Shortcuts.LAST_DAY:
          this.startDate = yesterday;
          this.endDate = yesterday;
          break;
        case Shortcuts.CURRENT_WEEK:
          this.startDate = moment(today)
            .add(1, "days")
            .startOf("week")
            .add(-1, "days")
            .format("YYYY-MM-DD");
          this.endDate = moment(today)
            .add(1, "days")
            .endOf("week")
            .add(-1, "days")
            .format("YYYY-MM-DD");
          break;
        case Shortcuts.CURRENT_MONTH:
          this.startDate = moment(today).startOf("jMonth").format("YYYY-MM-DD");
          this.endDate = moment(today).endOf("jMonth").format("YYYY-MM-DD");
          break;
      }
    },
    onDateChanged(startDate, endDate) {
      const date = [
        `${startDate} ${timeOfTheWorkingDay}:00`,
        `${moment(endDate)
          .add(1, "days")
          .format("YYYY-MM-DD")} ${timeOfTheWorkingDay}:00`,
      ];

      this.$emit("onDateChanged", date);
    },
    datePickerChanged() {
      this.selectedShortcut = Shortcuts.NONE;
    },
  },
  mounted() {
    this.onDateChanged(this.startDate, this.endDate);
  },
};
</script>

<style lang="scss">
.shortcut-container {
  margin: 10px 0;
}

.shortcut-item {
  border-radius: 20px;
  padding: 6px 20px 8px !important;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 10px 10px 10px 0;
  font-size: 0.8rem;
  color: gray;
  background-color: lightgray !important;
  font-weight: 500;

  &:hover {
    box-shadow: none !important;
  }
}

.shortcut-item-selected {
  background-color: rgba(var(--vs-primary), 1) !important;
  color: #fff;
}
</style>
